/**
 * Canonical format set for the conversations message-download surface
 * (PDF, DOCX, plain text) plus the matching MIME-type map.
 *
 * Single source of truth for three sites:
 *   - the Zod request schema (`ZConversations.DownloadMessageFile.Body.fileFormat`),
 *   - the backend port input type (`GenerateMessageFilePort`),
 *   - the controller's `Content-Type` header.
 *
 * Adding a new format requires updating the tuple and the MIME map in
 * lockstep — TypeScript's `Record<DownloadFileFormat, string>` makes a
 * missing entry a compile error.
 *
 * The legacy `AllowedFileFormats` enum (chat/chat.types.ts) carries
 * eleven variants for upload-side use cases (images, audio, archives);
 * those formats are deliberately NOT downloadable through the
 * conversations export pipeline.
 */
export const DOWNLOAD_FILE_FORMATS = ["pdf", "docx", "txt"] as const;

export type DownloadFileFormat = (typeof DOWNLOAD_FILE_FORMATS)[number];

export const DOWNLOAD_FILE_MIME_TYPES: Readonly<Record<DownloadFileFormat, string>> = {
  pdf: "application/pdf",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  txt: "text/plain"
};
